jQuery(document).ready(function ($) {
  if (homeslider == true) {
    // variable
    var VIDEO_PLAYING_STATE = {
      PLAYING: "PLAYING",
      PAUSE: "PAUSE",
    };
    var videoPlayStatus = VIDEO_PLAYING_STATE.PAUSE;
    var timeout = null;
    var waiting = 5000;
    var swiper = new Swiper(".swiper-banner", {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    // HTML5 vdo object
    var options = {};
    var player = videojs("my-player", options);
    // Event listener for when the video starts playing
    player.on("play", function () {
      player.addClass("visible"); // Add the 'visible' class to the player
    });
    player.on("ended", function () {
      player.removeClass("visible");
      next();
    });

    // swiper object
    swiper.on("slideChangeTransitionEnd", function () {
      var index = swiper.activeIndex;
      var currentSlide = $(swiper.slides[index]);
      var currentSlideType = currentSlide.data("slide-type");

      // incase user click next before video ended
      if (videoPlayStatus === VIDEO_PLAYING_STATE.PLAYING) {
        player.removeClass("visible");
        player.pause();
      }

      clearTimeout(timeout);

      switch (currentSlideType) {
        case "img":
          runNext();
          break;
        case "vdo":
          player.currentTime(0);

          player.play();
          player.addClass("visible");
          videoPlayStatus = VIDEO_PLAYING_STATE.PLAYING;
          break;
        default:
          throw new Error("invalid slide type");
      }
    });

    // global function
    function prev() {
      swiper.slidePrev();
    }

    function next() {
      swiper.slideNext();
    }

    function runNext() {
      timeout = setTimeout(function () {
        next();
      }, waiting);
    }

    // runNext();

    if (slidera) {
      var i;
      for (i = 0; i < slidera.length; ++i) {
        // do something with ``
        var j = i + 1;
        $(
          ".main-slider .swiper-pagination .swiper-pagination-bullet:nth-child(" +
            j +
            ")"
        ).html('<span style="background: url(' + slidera[i] + ');"></span>');
      }
    }
  }

  var $swiperSelector = $(".product-slider2");

  $swiperSelector.each(function (index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    var dragSize = $this.data("drag-size") ? $this.data("drag-size") : 150;
    var freeMode = $this.data("free-mode") ? $this.data("free-mode") : true;
    var loop = $this.data("loop") ? $this.data("loop") : false;
    var slidesDesktop = $this.data("slides-desktop")
      ? $this.data("slides-desktop")
      : 4;
    var slidesTablet = $this.data("slides-tablet")
      ? $this.data("slides-tablet")
      : 4;
    var slidesMobile = $this.data("slides-mobile")
      ? $this.data("slides-mobile")
      : 1;

    var swiper = new Swiper(".swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      spaceBetween: 0,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop,
        },
        992: {
          slidesPerView: slidesTablet,
        },
        320: {
          slidesPerView: slidesMobile,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: dragSize,
      },
    });
  });

  var $swiperSelector = $(".partner-items");
  $swiperSelector.each(function (index) {
    var $this = $(this);
    $this.addClass("partner-slider-" + index);
  });

  var leagueinit = false;
  var leaguetop, paernertop, paernertop2;
  function swiperCard() {
    if (window.innerWidth <= 768) {
      if (!leagueinit) {
        leagueinit = true;
        leaguetop = new Swiper(".choose-league-top", {
          direction: "horizontal",
          slidesPerView: 1,
          spaceBetween: 30,
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
            dragSize: 100,
          },
        });

        // paernertop = new Swiper('.partner-slider-0', {
        //     direction: "horizontal",
        //     slidesPerView: 3,
        //   slidesPerGroup: 3,
        //     autoplay: {
        //       delay: 2500,
        //       disableOnInteraction: false,
        //     },
        //     spaceBetween: 10,
        //     scrollbar: {
        //       el: '.swiper-scrollbar',
        //       draggable: true,
        //       dragSize: 50
        //     }
        // });
        // paernertops = new Swiper('.partner-slider-1', {
        //     direction: "horizontal",
        //     slidesPerView: 3,
        //   slidesPerGroup: 3,
        //     autoplay: {
        //       delay: 2500,
        //       disableOnInteraction: false,
        //     },
        //     spaceBetween: 10,
        //     scrollbar: {
        //       el: '.swiper-scrollbar',
        //       draggable: true,
        //       dragSize: 50
        //     }
        // });
      }
    } else if (leagueinit) {
      leaguetop.destroy();
      // leaguetop2.destroy();
      // paernertop.destroy();
      partnerinit = false;
    }
  }
  swiperCard();
  window.addEventListener("resize", swiperCard);

  var leaguetops = new Swiper(".state-top-area", {
    direction: "horizontal",
    freeMode: true,
    breakpoints: {
      1920: {
        slidesPerView: 6,
      },
      1300: {
        slidesPerView: 6,
      },
      992: {
        slidesPerView: 5,
      },
      320: {
        slidesPerView: 2,
      },
    },
    spaceBetween: 30,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      dragSize: 100,
    },
  });

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    //>=, not <=
    if (scroll >= 100) {
      //clearHeader, not clearheader - caps H
      $(".header-wrapper").addClass("stick-now");
    } else {
      $(".header-wrapper").removeClass("stick-now");
    }
  }); //missing );

  // var slideWrapper = $(".banner-slider"),
  //     iframes = slideWrapper.find('.embed-player'),
  //     lazyImages = slideWrapper.find('.slide-image'),
  //     lazyCounter = 0;

  //     // POST commands to YouTube or Vimeo API
  //     function postMessageToPlayer(player, command){
  //       if (player == null || command == null) return;
  //       player.contentWindow.postMessage(JSON.stringify(command), "*");
  //     }

  //     // When the slide is changing
  //     function playPauseVideo(slick, control){
  //       var currentSlide, slideType, startTime, player, video;

  //       currentSlide = slick.find(".slick-current");
  //       slideType = currentSlide.attr("class").split(" ")[1];
  //       player = currentSlide.find("iframe").get(0);
  //       startTime = currentSlide.data("video-start");

  //       if (slideType === "vimeo") {
  //         switch (control) {
  //           case "play":
  //             if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
  //               currentSlide.addClass('started');
  //               postMessageToPlayer(player, {
  //                 "method": "setCurrentTime",
  //                 "value" : startTime
  //               });
  //             }
  //             postMessageToPlayer(player, {
  //               "method": "play",
  //               "value" : 1
  //             });
  //             break;
  //           case "pause":
  //             postMessageToPlayer(player, {
  //               "method": "pause",
  //               "value": 1
  //             });
  //             break;
  //         }
  //       } else if (slideType === "youtube-sound") {
  //         switch (control) {
  //           case "play":
  //             postMessageToPlayer(player, {
  //               "event": "command",
  //               // "func": "mute"
  //             });
  //             postMessageToPlayer(player, {
  //               "event": "command",
  //               "func": "playVideo"
  //             });
  //             break;
  //           case "pause":
  //             postMessageToPlayer(player, {
  //               "event": "command",
  //               "func": "pauseVideo"
  //             });
  //             break;
  //         }
  //       }  else if (slideType === "youtube") {
  //         switch (control) {
  //           case "play":
  //             postMessageToPlayer(player, {
  //               "event": "command",
  //               "func": "mute"
  //             });
  //             postMessageToPlayer(player, {
  //               "event": "command",
  //               "func": "playVideo"
  //             });
  //             break;
  //           case "pause":
  //             postMessageToPlayer(player, {
  //               "event": "command",
  //               "func": "pauseVideo"
  //             });
  //             break;
  //         }
  //       } else if (slideType === "video") {
  //         video = currentSlide.children(".slider-image").children(".slider-video").children("video").get(0);
  //         console.log(video);
  //         if (video != null) {
  //           if (control === "play"){
  //             video.play();
  //           } else {
  //             video.pause();
  //           }
  //         }
  //       }
  //     }

  // // Resize player
  // function resizePlayer(iframes, ratio) {
  //   if (!iframes[0]) return;
  //   var win = $(".banner-slider"),
  //       width = win.width(),
  //       playerWidth,
  //       height = win.height(),
  //       playerHeight,
  //       ratio = ratio || 16/9;

  //   iframes.each(function(){
  //     var current = $(this);
  //     if (width / ratio < height) {
  //       playerWidth = Math.ceil(height * ratio);
  //       current.width(playerWidth).height(height).css({
  //         left: (width - playerWidth) / 2,
  //          top: 0
  //         });
  //     } else {
  //       playerHeight = Math.ceil(width / ratio);
  //       current.width(width).height(playerHeight).css({
  //         left: 0,
  //         top: (height - playerHeight) / 2
  //       });
  //     }
  //   });
  // }
  //   slideWrapper.on("init", function(slick){
  //     slick = $(slick.currentTarget);
  //     setTimeout(function(){
  //       playPauseVideo(slick,"play");
  //     }, 1000);
  //     // resizePlayer(iframes, 16/9);
  //   });
  //   slideWrapper.on("beforeChange", function(event, slick) {
  //     slick = $(slick.$slider);
  //     playPauseVideo(slick,"pause");
  //   });
  //   slideWrapper.on("afterChange", function(event, slick) {
  //     slick = $(slick.$slider);
  //     playPauseVideo(slick,"play");
  //   });
  //   // slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
  //   //   lazyCounter++;
  //   //   if (lazyCounter === lazyImages.length){
  //   //     lazyImages.addClass('show');
  //       // slideWrapper.slick("slickPlay");
  //   //   }
  //   // });

  //     slideWrapper.slick({
  //         autoplay: true,
  //         autoplaySpeed: 7000,
  //         draggable: false,
  //         infinite: true,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows: false,
  //         dots: true,
  //         fade: true,
  //         cssEase: 'linear'
  //     });
  var $swiperLeagues = $(".choose-leagues");

  $swiperLeagues.each(function (index) {
    var $this = $(this);
    $this.addClass("swiper-slider-" + index);

    var dragSize = $this.data("drag-size") ? $this.data("drag-size") : 50;
    var freeMode = $this.data("free-mode") ? $this.data("free-mode") : false;
    var loop = $this.data("loop") ? $this.data("loop") : false;

    var swiper = new Swiper(".swiper-slider-" + index, {
      direction: "horizontal",
      loop: loop,
      freeMode: freeMode,
      spaceBetween: 0,
      breakpoints: {
        1920: {
          slidesPerView: 4,
        },
        992: {
          slidesPerView: 4,
        },
        320: {
          slidesPerView: 1,
        },
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: dragSize,
      },
    });
    $this.find(".swiper-button-prevs").click(function (e) {
      e.preventDefault();
      Myprev();
    });
    $this.find(".swiper-button-nexts").click(function (e) {
      e.preventDefault();
      Mynext();
    });

    function Myprev() {
      var index = swiper.activeIndex;
      var currentSlide = $(swiper.slides[index - 1]);
      currentSlide.trigger("click");
      swiper.slidePrev();
    }

    function Mynext() {
      var index = swiper.activeIndex;
      var currentSlide = $(swiper.slides[index + 1]);
      currentSlide.trigger("click");
      swiper.slideNext();
    }
  });

  // $('.choose-leagues').each(function(num, elem) {
  //     elem = $(elem);
  //     elem.slick({
  //         slidesToShow: 4,
  //         slidesToScroll: 1,
  //         arrows: true,
  //         draggable: true,
  //         fade: false,
  //         dots: true,
  //         infinite: false,
  //         responsive: [
  //           {
  //             breakpoint: 1024,
  //             settings: {
  //               slidesToShow: 4,
  //               slidesToScroll: 1
  //             }
  //           },
  //           {
  //             breakpoint: 600,
  //             settings: {
  //               slidesToShow: 2,
  //               slidesToScroll: 2
  //             }
  //           },
  //           {
  //             breakpoint: 480,
  //             settings: {
  //               slidesToShow: 1,
  //               slidesToScroll: 1
  //             }
  //           }
  //         ]
  //     });
  // });

  $(".slick-banner").slick({
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });
  var $slider2 = $(".product-slider");
  $slider2.slick({
    autoplay: true,
    draggable: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // var $progressBar = $('.progress');
  // var $progressBarLabel = $( '.slider__label' );

  // $slider2.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  //   var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

  //   $progressBar
  //     .css('background-size', calc + '% 100%')
  //     .attr('aria-valuenow', calc );

  //   $progressBarLabel.text( calc + '% completed' );
  // });

  $(".all-reviews").slick({
    autoplay: true,
    slidesToShow: 1,
    centerPadding: "500px",
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
    dots: false,
    autoplaySpeed: 2000,
    speed: 800,
    infinite: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          centerPadding: "350px",
        },
      },
      {
        breakpoint: 1400,
        settings: {
          centerPadding: "300px",
        },
      },
      {
        breakpoint: 1024,
        settings: {
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 600,
        settings: {
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: "30px",
        },
      },
    ],
  });
  if (slidera) {
    var i;
    for (i = 0; i < slidera.length; ++i) {
      // do something with ``
      var j = i + 1;
      $(".banner-slider .slick-dots li:nth-child(" + j + ")").html(
        '<button style="background: url(' + slidera[i] + ');"></button>'
      );
    }
  }

  var $grid = $(".grid-images").isotope({
    itemSelector: ".mygrid-area",
    percentPosition: true,
    masonry: {
      columnWidth: ".grid-sizer",
    },
  });
  $grid.imagesLoaded().progress(function () {
    $grid.isotope("layout");
  });
  $(".single-equipment").click(function (e) {
    e.preventDefault();
    var equipment = $(this).data("tab");
    $(".single-equipment").removeClass("active");
    $(this).addClass("active");
    $(".common-tab").removeClass("active");
    $("#" + equipment).addClass("active");
  });
  $('input[name="random_chnage"]')
    .change(function () {
      $("#SortBy option[value=" + $(this).val() + "]").attr(
        "selected",
        "selected"
      );
    })
    .trigger("change");
  //Get Exising Select Options
  // $('#SortBy').each(function(i, select){
  //     var $select = $(select);
  //     $select.find('option').each(function(j, option){
  //         var $option = $(option);
  //         // Create a radio:
  //         var $radio = $('<input type="radio" />');
  //         // Set name and value:
  //         $radio.attr('name', $select.attr('name')).attr('value', $option.val());
  //         // Set checked if the option was selected
  //         if ($option.attr('selected')) $radio.attr('checked', 'checked');
  //         // Insert radio before select box:
  //         $select.before($radio);
  //         // Insert a label:
  //         $select.before(
  //           $("<label />").attr('for', $select.attr('name')).text($option.text())
  //         );
  //         // Insert a <br />:
  //         $select.before("<br/>");
  //     });
  //     // $select.remove();
  // });

  $(".small img").click(function (e) {
    e.preventDefault();
    var gallery = $(this).parents(".gallery");
    var bigimg = $(this).data("big");
    gallery.find(".feature >img").attr("src", bigimg);
    gallery.find(".small").removeClass("active");
    $(this).parent().addClass("active");
  });

  $(".single-choose-league").click(function (e) {
    e.preventDefault();
    var newid = $(this).data("tab");
    $(".common-tab").removeClass("active");
    $(".single-choose-league").removeClass("active");
    $(this).addClass("active");
    $("#" + newid).addClass("active");
    $("#" + newid)
      .find(".single-choose-project:first-child")
      .trigger("click");
  });

  $(".three-balls ul li").click(function (e) {
    e.preventDefault();
    var newid = $(this).data("tab");
    $(".common-gallery").removeClass("active");
    $(".three-balls ul li").removeClass("active");
    $(this).addClass("active");
    $("#" + newid).addClass("active");
  });

  $(".single-choose-project").click(function (e) {
    e.preventDefault();
    var newid = $(this).data("tab");
    var sports = $(this).data("sports");
    $(".common-gallery").removeClass("active");
    $(".three-balls").removeClass("active");
    $(this).parent().find(".single-choose-project").removeClass("active");
    $(this).addClass("active");
    $("#" + newid).addClass("active");
    $("#" + sports).addClass("active");
  });
  //   const slider = document.querySelector('.choose-leagues');
  // let isDown = false;
  // let startX;
  // let scrollLeft;

  // slider.addEventListener('mousedown', (e) => {
  //   isDown = true;
  //   slider.classList.add('active');
  //   startX = e.pageX - slider.offsetLeft;
  //   scrollLeft = slider.scrollLeft;
  // });
  // slider.addEventListener('mouseleave', () => {
  //   isDown = false;
  //   slider.classList.remove('active');
  // });
  // slider.addEventListener('mouseup', () => {
  //   isDown = false;
  //   slider.classList.remove('active');
  // });
  // slider.addEventListener('mousemove', (e) => {
  //   if(!isDown) return;
  //   e.preventDefault();
  //   const x = e.pageX - slider.offsetLeft;
  //   const walk = (x - startX) * 3; //scroll-fast
  //   slider.scrollLeft = scrollLeft - walk;
  //   console.log(walk);
  // });
});

class CountUp {
  constructor(triggerEl, counterEl) {
    const counter = document.querySelector(counterEl);
    const trigger = document.querySelector(triggerEl);
    let num = 0;
    const decimals = counter.dataset.decimals;

    const countUp = () => {
      if (num < counter.dataset.stop)
        if (decimals) {
          // Do we want decimals?
          num += 0.01;
          counter.textContent = new Intl.NumberFormat("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(num);
        } else {
          // No decimals
          num++;
          counter.textContent = num;
        }
    };

    const observer = new IntersectionObserver(
      (el) => {
        if (el[0].isIntersecting) {
          const interval = setInterval(() => {
            num < counter.dataset.stop ? countUp() : clearInterval(interval);
          }, counter.dataset.speed);
        }
      },
      { threshold: [0] }
    );

    observer.observe(trigger);
  }
}

// Initialize any number of counters:
new CountUp("#export-areas", "#number1");
new CountUp("#export-areas", "#number2");
new CountUp("#export-areas", "#number3");
